/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedSubscriptionListSchema } from '../models/PagedSubscriptionListSchema';
import type { PagedSubscriptionPaymentListSchema } from '../models/PagedSubscriptionPaymentListSchema';
import type { SubscriptionCreateSchema } from '../models/SubscriptionCreateSchema';
import type { SubscriptionDetailSchema } from '../models/SubscriptionDetailSchema';
import type { SubscriptionListExportSchema } from '../models/SubscriptionListExportSchema';
import type { SubscriptionPaymentCreateSchema } from '../models/SubscriptionPaymentCreateSchema';
import type { SubscriptionPaymentDetailSchema } from '../models/SubscriptionPaymentDetailSchema';
import type { SubscriptionPaymentUpdateSchema } from '../models/SubscriptionPaymentUpdateSchema';
import type { SubscriptionUpdateSchema } from '../models/SubscriptionUpdateSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubscriptionsApi {
    /**
     * Assign Patient
     * Assign patient to subscription. <br> Required Permissions: UPDATE_SUBSCRIPTION
     * @returns void
     * @throws ApiError
     */
    public static subscriptionsAssignPatientPost({
        subscriptionId,
        patientId,
    }: {
        subscriptionId: string,
        patientId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/subscriptions/{subscription_id}/patients/{patient_id}',
            path: {
                'subscription_id': subscriptionId,
                'patient_id': patientId,
            },
        });
    }
    /**
     * Unassign Patient
     * Unassign patient from subscription. <br> Required Permissions: UPDATE_SUBSCRIPTION
     * @returns void
     * @throws ApiError
     */
    public static subscriptionsUnassignPatientDelete({
        subscriptionId,
        patientId,
    }: {
        subscriptionId: string,
        patientId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/subscriptions/{subscription_id}/patients/{patient_id}',
            path: {
                'subscription_id': subscriptionId,
                'patient_id': patientId,
            },
        });
    }
    /**
     * Create Subscription
     * Create subscription. <br>Required Permission: 'create_subscription'
     * @returns SubscriptionDetailSchema Created
     * @throws ApiError
     */
    public static subscriptionsCreateSubscriptionPost({
        requestBody,
    }: {
        requestBody: SubscriptionCreateSchema,
    }): CancelablePromise<SubscriptionDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/subscriptions/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Subscription List
     * Get list of company subscriptions. <br>Required Permission: 'list_subscriptions'
     * @returns PagedSubscriptionListSchema OK
     * @throws ApiError
     */
    public static subscriptionsGetSubscriptionListGet({
        orderBy,
        name,
        searching,
        patientId,
        limit = 100,
        offset,
    }: {
        orderBy?: (string | null),
        name?: (string | null),
        searching?: (string | null),
        patientId?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedSubscriptionListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/subscriptions/',
            query: {
                'order_by': orderBy,
                'name': name,
                'searching': searching,
                'patient_id': patientId,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Create Subscription Payment
     * Create subscription payment. <br>Required Permission: 'create_subscription_payment'
     * @returns SubscriptionPaymentDetailSchema Created
     * @throws ApiError
     */
    public static subscriptionsCreateSubscriptionPaymentPost({
        subscriptionId,
        requestBody,
    }: {
        subscriptionId: string,
        requestBody: SubscriptionPaymentCreateSchema,
    }): CancelablePromise<SubscriptionPaymentDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/subscriptions/{subscription_id}/subscription-payments/',
            path: {
                'subscription_id': subscriptionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Subscription Payment List
     * Get list of company subscription's payments. <br>Required Permission: 'list_subscription_payments'
     * @returns PagedSubscriptionPaymentListSchema OK
     * @throws ApiError
     */
    public static subscriptionsGetSubscriptionPaymentListGet({
        subscriptionId,
        orderBy,
        limit = 100,
        offset,
    }: {
        subscriptionId: string,
        orderBy?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedSubscriptionPaymentListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/subscriptions/{subscription_id}/subscription-payments/',
            path: {
                'subscription_id': subscriptionId,
            },
            query: {
                'order_by': orderBy,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Delete Subscription
     * Delete subscription. <br> Required Permissions: DELETE_SUBSCRIPTION
     * @returns void
     * @throws ApiError
     */
    public static subscriptionsDeleteSubscriptionDelete({
        subscriptionId,
    }: {
        subscriptionId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/subscriptions/{subscription_id}',
            path: {
                'subscription_id': subscriptionId,
            },
        });
    }
    /**
     * Get Subscription
     * Get subscription detail. <br>Required Permission: 'get_subscription'
     * @returns SubscriptionDetailSchema OK
     * @throws ApiError
     */
    public static subscriptionsGetSubscriptionGet({
        subscriptionId,
    }: {
        subscriptionId: string,
    }): CancelablePromise<SubscriptionDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/subscriptions/{subscription_id}',
            path: {
                'subscription_id': subscriptionId,
            },
        });
    }
    /**
     * Update Subscription
     * Update subscription. <br>Required Permission: 'update_subscription'
     * @returns SubscriptionDetailSchema OK
     * @throws ApiError
     */
    public static subscriptionsUpdateSubscriptionPut({
        subscriptionId,
        requestBody,
    }: {
        subscriptionId: string,
        requestBody: SubscriptionUpdateSchema,
    }): CancelablePromise<SubscriptionDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/subscriptions/{subscription_id}',
            path: {
                'subscription_id': subscriptionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generate Subscription Export
     * Generate export of subscriptions and their payments. Required Permission: list_subscriptions
     * @returns any Accepted
     * @throws ApiError
     */
    public static subscriptionsGenerateSubscriptionExportPost({
        requestBody,
    }: {
        requestBody: SubscriptionListExportSchema,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/subscriptions/export/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Subscription Payment
     * Get subscription payment. <br>Required Permission: 'get_subscription_payment'
     * @returns SubscriptionPaymentDetailSchema OK
     * @throws ApiError
     */
    public static subscriptionsGetSubscriptionPaymentGet({
        subscriptionId,
        subscriptionPaymentId,
    }: {
        subscriptionId: string,
        subscriptionPaymentId: string,
    }): CancelablePromise<SubscriptionPaymentDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/subscriptions/{subscription_id}/subscription-payments/{subscription_payment_id}/',
            path: {
                'subscription_id': subscriptionId,
                'subscription_payment_id': subscriptionPaymentId,
            },
        });
    }
    /**
     * Update Subscription Payment
     * Update subscription payment. <br>Required Permission: 'update_subscription_payment'
     * @returns SubscriptionPaymentDetailSchema OK
     * @throws ApiError
     */
    public static subscriptionsUpdateSubscriptionPaymentPut({
        subscriptionId,
        subscriptionPaymentId,
        requestBody,
    }: {
        subscriptionId: string,
        subscriptionPaymentId: string,
        requestBody: SubscriptionPaymentUpdateSchema,
    }): CancelablePromise<SubscriptionPaymentDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/subscriptions/{subscription_id}/subscription-payments/{subscription_payment_id}/',
            path: {
                'subscription_id': subscriptionId,
                'subscription_payment_id': subscriptionPaymentId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
